import { KuposCounter, KuposErrorSuccessModal } from '../../common';
import React, { Component, useEffect, useRef, useState } from 'react';

import { AppData } from '../../../services';
import CancellationInputs from './RenderInputs/CancellationInputs';
import ChangeTicketInputs from './RenderInputs/ChangeTicketInput';
import ConfirmTicketInputs from './RenderInputs/ConfirmTicketInputs';
import CuponeraInputs from '../../common/Cuponera/CuponeraInputs';
import { KuposRadio } from '../../common';
import RenderInputs from './RenderInputs/RenderInputs';

function HomeSearchBoxPB({
  onwardDate,
  returnDate,
  onwardDateChange,
  returnDateChange,
  selectSourceCity,
  selectDestinationCity,
  sourceCityOptions,
  destinationCityOptions,
  sourceCityOnChange,
  destinationCityOnChange,
  sourcePlaceholder,
  destinationPlaceholder,
  onSearch,
  t,
  selectedSearchApp,
  loadTicketDetails,
  history,
  apiCall,
  actions,
  is_mot,
  common,
}) {
  const [selectOptionsUpdate, setSelectOptionsUpdate] = useState('');
  const [selectOptions2Update, setSelectOptions2Update] = useState('');
  const [selectOptions, setSelectOptions] = useState('');
  const [selectOptions2, setSelectOptions2] = useState('');
  const [sourceCityError, setSourceCityError] = useState('');
  const [destinationCityError, setDestinationCityError] = useState('');
  const [dateErrorReturn, setDateErrorReturn] = useState('');
  const [destinationType, setDestinationType] = useState('');

  const pullmanSearchBarOptions = [
    {
      id: 1,
      is_mot: false,
      label: t('HOME.BUY_YOUR_TICKET'),
      img: '/images/search-bar/search-bar-buy-a-ticket.svg',
    },
    {
      id: 2,
      is_mot: false,
      label: t('HOME.CHANGE_YOUR_TICKET'),
      img: '/images/search-bar/search-bar-change-a-ticket.svg',
    },

    {
      id: 4,
      is_mot: false,
      label: t('HOME.CANCEL_YOUR_TICKET'),
      img: '/images/search-bar/search-bar-cancel-a-ticket.svg',
    },

    // {
    //   id: 5,
    //   is_mot: true,
    //   label: t('HOME.IS_MOT'),
    //   img: '/images/search-bar/search-bar-confirm-a-ticket.svg',
    // },
    // {
    //   id: 6,
    //   is_mot: false,
    //   label: t('HOME.CUPONERA'),
    //   img: '/images/search-bar/search-bar-confirm-a-ticket.svg',
    // },
  ];

  const [select1, setSelect1] = useState('');
  const [select2, setSelect2] = useState('');
  const [travels, setTravels] = useState([]);
  // const [select4, setSelect4] = useState('');

  const [selectedOption, setSelectedOption] = useState(1);
  const [selectedRadio, setSelectedRadio] = useState('online');

  const destinationRef = useRef(null);

  useEffect(() => {
    if (!selectOptionsUpdate && sourceCityOptions) {
      setSelectOptions(sourceCityOptions);
      setSelectOptionsUpdate(true);
    }
    if (!selectOptions2Update && destinationCityOptions) {
      setSelectOptions2(destinationCityOptions);
      setSelectOptions2Update(true);
    }
  });

  // is_mot
  useEffect(() => {
    apiCall({
      url: AppData.BASE_URL + 'api/direct_cancel_operators',
    }).then(
      res => onTravelsApiResponse(res),
      err => {},
    );

    if (is_mot) {
      selectOption(pullmanSearchBarOptions[3]);
    }
  }, []);

  const onTravelsApiResponse = res => {
    if (res && res.data) {
      let travels = [];
      res.data.map(item => {
        travels.push({
          value: item[1],
          id: item[1],
          label: item[0],
          name: item[0],
        });
      });
      setTravels(travels);
    }
  };

  const clearSelectValues = () => {
    if (select1) select1.clearValue();
    if (select2) select2.clearValue();
  };
  const onInputChange = (val, type) => {};

  const onInputChange2 = (val, type) => {};

  const search = e => {
    e.preventDefault();
    let errorCount = 0;
    if (!selectSourceCity) {
      setSourceCityError('VALIDATIONS.VALID_ORIGIN_CITY');
      errorCount++;
    }
    if (!selectDestinationCity) {
      setDestinationCityError('VALIDATIONS.VALID_DESTINATION_CITY');
      errorCount++;
    }

    if (errorCount <= 0) onSearch();
  };

  const onSourceChange = value => {
    setSourceCityError(null);
    sourceCityOnChange(value);
    getOriginSelectedFilteredDestinations(selectOptions2, selectSourceCity);

    if (selectDestinationCity && value && selectDestinationCity.value == value.value) {
      destinationCityOnChange(null);
    }

    destinationRef.current.onMenuOpen();
    destinationRef.current.select.focus();
  };

  const onDestinationChange = value => {
    setDestinationCityError(null);
    destinationCityOnChange(value);
  };

  const getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
    if (rawArray && itemToRemove) {
      return rawArray
        .map(function(obj) {
          if (obj.label == itemToRemove.label) {
          } else {
            return obj;
          }
        })
        .filter(function(obj) {
          return typeof obj !== 'undefined';
        });
    } else if (!itemToRemove) {
      // return rawArray;
    }
  };

  // const getOriginSelectedFilteredDestinationsTrain = (rawArray, itemToRemove) => {
  //   if (rawArray && itemToRemove) {
  //     return rawArray
  //       .map(function(obj) {
  //         if (obj.label == itemToRemove.label) {
  //         } else {
  //           return obj;
  //         }
  //       })
  //       .filter(function(obj) {
  //         return typeof obj !== 'undefined';
  //       });
  //   } else if (!itemToRemove) {
  //     // return rawArray;
  //   }
  // };

  const selectOption = item => {
    actions.setIsMot(item.is_mot);
    setSelectedOption(item.id);
  };

  return (
    <div className={'  ' + (selectedSearchApp == 2 ? 'airport-transfer' : '')}>
      <div className="content-container pullman-search-box-options">
        {pullmanSearchBarOptions.map((item, index) => (
          <div
            className={`pointer pullman-search-box-item  ${
              index % 2 === 0 ? 'light-blue' : 'middle-light-blue'
            } ${selectedOption === item.id && ' selected '}`}
            onClick={() => selectOption(item)}
          >
            <img src={item.img} alt="" />
            <span style={{ fontSize: '15px' }}>{item.label}</span>
          </div>
        ))}
      </div>
      <div className={`pullman-search-box-card `}>
        {selectedOption === 1 && (
          <div className="content-container">
            <RenderInputs
              selectedSearchApp={selectedSearchApp}
              t={t}
              select1={select1}
              select2={select2}
              setSelect1={setSelect1}
              setSelect2={setSelect2}
              sourcePlaceholder={sourcePlaceholder}
              selectOptions={selectOptions}
              selectSourceCity={selectSourceCity}
              onSourceChange={onSourceChange}
              onInputChange={onInputChange}
              sourceCityError={sourceCityError}
              // select2={select2}
              getOriginSelectedFilteredDestinations={getOriginSelectedFilteredDestinations}
              selectOptions2={selectOptions2}
              selectDestinationCity={selectDestinationCity}
              onDestinationChange={onDestinationChange}
              onInputChange2={onInputChange2}
              destinationPlaceholder={destinationPlaceholder}
              KuposCounter={KuposCounter}
              destinationCityError={destinationCityError}
              destinationType={destinationType}
              onwardDate={onwardDate}
              onwardDateChange={onwardDateChange}
              returnDate={returnDate}
              returnDateChange={returnDateChange}
              dateErrorReturn={dateErrorReturn}
              search={search}
              destinationRef={destinationRef}
            />
          </div>
        )}
        {selectedOption === 2 && (
          <div className="content-container relative">
            {/* <ChangeTicketInputs
              t={t}
              activeTab={selectedOption}
              loadTicketDetails={loadTicketDetails}
              history={history}
            /> */}
            {/* <div className=" flex-row gap-30 myn-15 font10">
              {' '}
              <KuposRadio
                checked={selectedRadio === 'online' ? true : false}
                label={'Pasaje online'}
                onClick={() => setSelectedRadio('online')}
              />
              <KuposRadio
                checked={selectedRadio === 'offline' ? true : false}
                label={'Pasaje ventanilla'}
                onClick={() => setSelectedRadio('offline')}
              />
            </div> */}
            <CancellationInputs
              t={t}
              activeTab={selectedOption}
              loadTicketDetails={loadTicketDetails}
              history={history}
              is_change_ticket={true}
              cancel_mode={selectedRadio}
              travels={travels}
              apiCall={apiCall}
              actions={actions}
            />
          </div>
        )}
        {/* {selectedOption === 3 && (
          <div className="content-container relative">
            <ConfirmTicketInputs
              t={t}
              activeTab={selectedOption}
              apiCall={apiCall}
              history={history}
              uniqueCities={sourceCityOptions}
            />
          </div>
        )} */}
        {selectedOption === 4 && (
          <div className="content-container relative">
            {/* <div className=" flex-row gap-30 myn-15 font10">
              {' '}
              <KuposRadio
                checked={selectedRadio === 'online' ? true : false}
                label={'Pasaje online'}
                onClick={() => setSelectedRadio('online')}
              />
              <KuposRadio
                checked={selectedRadio === 'offline' ? true : false}
                label={'Pasaje ventanilla'}
                onClick={() => setSelectedRadio('offline')}
              />
            </div> */}
            <CancellationInputs
              t={t}
              activeTab={selectedOption}
              loadTicketDetails={loadTicketDetails}
              history={history}
              is_change_ticket={false}
              cancel_mode={selectedRadio}
              travels={travels}
              apiCall={apiCall}
              actions={actions}
            />
          </div>
        )}

        {selectedOption === 5 && (
          <div className="content-container">
            <RenderInputs
              selectedSearchApp={selectedSearchApp}
              t={t}
              select1={select1}
              select2={select2}
              setSelect1={setSelect1}
              setSelect2={setSelect2}
              sourcePlaceholder={sourcePlaceholder}
              selectOptions={selectOptions}
              selectSourceCity={selectSourceCity}
              onSourceChange={onSourceChange}
              onInputChange={onInputChange}
              sourceCityError={sourceCityError}
              // select2={select2}
              getOriginSelectedFilteredDestinations={getOriginSelectedFilteredDestinations}
              selectOptions2={selectOptions2}
              selectDestinationCity={selectDestinationCity}
              onDestinationChange={onDestinationChange}
              onInputChange2={onInputChange2}
              destinationPlaceholder={destinationPlaceholder}
              KuposCounter={KuposCounter}
              destinationCityError={destinationCityError}
              destinationType={destinationType}
              onwardDate={onwardDate}
              onwardDateChange={onwardDateChange}
              returnDate={returnDate}
              returnDateChange={returnDateChange}
              dateErrorReturn={dateErrorReturn}
              search={search}
              destinationRef={destinationRef}
            />
          </div>
        )}

        {selectedOption === 6 && (
          <div className="content-container">
            <CuponeraInputs
              t={t}
              selectOptions={selectOptions}
              selectOptions2={selectOptions2}
              onInputChange={onInputChange}
              onInputChange2={onInputChange2}
              getOriginSelectedFilteredDestinations={getOriginSelectedFilteredDestinations}
              history={history}
              actions={actions}
              common={common}
              loading={() => {}}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default HomeSearchBoxPB;



// WEBPACK FOOTER //
// ./src/features/home/HomeSearchBoxPB/HomeSearchBoxPB.js